// Business data for CYBERNET Cortazar. Edit here to update the whole site.

export const BUSINESS = {
  name: "CYBERNET",
  city: "Cortazar, Gto.",
  years: 20,
  since: 2004,
  tagline: "Tecnología, trámites y papelería en un solo lugar.",
  intro:
    "20 años dedicados a satisfacer las necesidades en Tecnologías de la Información, servicio técnico, impresión y trámites digitales.",
  primaryWhatsapp: "524111352015", // Sucursal Cuauhtémoc (principal)
  facebook: "https://www.facebook.com/cybernet.cortazar/",
  email: "cybernet.cortazar@gmail.com",
};

export const LOGOS = {
  mark: "/cn-mark.png",
  wordmark: "/cn-wordmark.png",
};

export const POSTERS = {
  servicioTecnico: "/svc-tecnico.jpg",
  tramitesDigitales: "/svc-tramites.jpg",
  papeleria: "/svc-papeleria.jpg",
  consumibles: "/svc-consumibles.jpg",
};

export const SERVICES = [
  {
    id: "tramites",
    number: "01",
    title: "Trámites y Servicios Digitales",
    short:
      "Gestionamos tus trámites SAT, actas, citas y más, de forma rápida y confiable.",
    image: POSTERS.tramitesDigitales,
    items: [
      "SAT — Constancia de Situación Fiscal RFC · Citas",
      "Actas: Nacimiento, Matrimonio, Divorcio y Defunción",
      "Carta de Antecedentes No Penales y Disciplinarios",
      "Citas: Licencia de Manejo, INE, IMSS, Registro Civil, Revisión Vehicular",
      "Buró de Crédito",
      "IMSS: Número de Seguro Social · Vigencia · Semanas Cotizadas",
      "INFONAVIT: Aviso de Suspensión y Retención · Estados de Cuenta",
      "Y muchos trámites más…",
    ],
  },
  {
    id: "tecnico",
    number: "02",
    title: "Servicio Técnico Especializado",
    short:
      "Mantenimiento, reparación e instalación para tus equipos e infraestructura.",
    image: POSTERS.servicioTecnico,
    items: [
      "Formateo de Laptops, All-in-one y PC's",
      "Instalación de Programas",
      "Servicio Integral a Smartphones y Tablets",
      "Reparación de impresoras",
      "Instalación de Cámaras de Seguridad Residencial y Comercial (Analógicas / IP)",
      "Instalación de Puntos de Venta",
      "Recarga de Cartuchos de Tinta y Toner",
      "Digitalización: Videos VHS, 8mm, Beta a DVD o memoria USB",
      "Casetes de audio a memoria USB",
    ],
  },
  {
    id: "papeleria",
    number: "03",
    title: "Papelería",
    short:
      "Todo lo que necesitas para la escuela, oficina y trabajo diario.",
    image: POSTERS.papeleria,
    items: [
      "Papelería escolar y de oficina",
      "Impresión negro láser (hasta tabloide)",
      "Impresión a color láser y tinta (hasta tabloide)",
      "Copias, escaneo y engargolado",
      "Enmicado y acabados",
      "Recargas telefónicas",
      "Servicio de internet por hora",
    ],
  },
  {
    id: "consumibles",
    number: "04",
    title: "Consumibles y Accesorios Tecnológicos",
    short:
      "Amplia gama de accesorios, consumibles y equipo de cómputo original.",
    image: POSTERS.consumibles,
    items: [
      "Memorias USB y Micro SD",
      "Cables, adaptadores y hubs",
      "Cartuchos de tinta y toner",
      "Mouse, teclados y accesorios",
      "Cargadores para celulares",
      "Cámaras de seguridad",
      "Equipo de cómputo e impresión",
      "Consumibles originales HP, Epson, Canon, Brother",
    ],
  },
];

export const BRANCHES = [
  {
    id: "cuauhtemoc",
    name: "CYBERNET Cuauhtémoc",
    year: 2012,
    address: "Cuauhtémoc #117 Local 4, Centro, Cortazar, Gto.",
    phone: "411-135-2015",
    phoneRaw: "524111352015",
    email: "cybernet.sic@gmail.com",
    hours: [
      "Lunes a Viernes: 10:00 am — 8:30 pm",
      "Sábado y Domingo: 10:30 am — 6:00 pm",
    ],
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=Cuauhtémoc+117+Cortazar+Gto",
    highlight: "Sucursal principal · Servicio técnico y venta especializada",
  },
  {
    id: "madero",
    name: "CYBERNET Madero",
    year: 2004,
    address: "Francisco I. Madero #113, Centro, Cortazar, Gto.",
    phone: "411-161-1253",
    phoneRaw: "524111611253",
    email: "cybernet.madero@gmail.com",
    hours: [
      "Lunes a Viernes: 10:00 am — 8:30 pm",
      "Sábado y Domingo: 10:30 am — 3:30 pm",
    ],
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=Francisco+I+Madero+113+Cortazar+Gto",
    highlight: "Nuestra primera sucursal · Desde 2004",
  },
  {
    id: "alamos",
    name: "CYBERNET Álamos",
    year: 2005,
    address: "21 de Marzo #320 D, Cortazar, Gto.",
    phone: "411-144-3964",
    phoneRaw: "524111443964",
    email: "cybernet.alamos@gmail.com",
    hours: [
      "Lunes a Viernes: 10:00 am — 8:30 pm",
      "Sábado y Domingo: 10:30 am — 6:00 pm",
    ],
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=21+de+Marzo+320+Cortazar+Gto",
    highlight: "Papelería, impresión y trámites",
  },
  {
    id: "boulevard",
    name: "CYBERCLIC Boulevard",
    year: 2025,
    address: "Blvd. Paseo de la Juventud #706, Cortazar, Gto.",
    phone: "411-118-8639",
    phoneRaw: "524111188639",
    email: "cyberclic.cortazar@gmail.com",
    hours: [
      "Lunes a Viernes: 6:30 am — 6:00 pm",
      "Sábado y Domingo: Cerrado",
    ],
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=Blvd+Paseo+de+la+Juventud+706+Cortazar+Gto",
    highlight: "Nuestra sucursal más nueva",
  },
];

export const VALUES = [
  { title: "Honestidad", desc: "Transparencia en cada trato y servicio." },
  { title: "Eficacia", desc: "Resolvemos con precisión y rapidez." },
  { title: "Trabajo de equipo", desc: "Colaboramos para dar la mejor solución." },
  { title: "Responsabilidad", desc: "Cumplimos lo que prometemos." },
  { title: "Respeto", desc: "Cada cliente es atendido con calidez." },
];

export const ADVANTAGES = [
  {
    icon: "UserCheck",
    title: "Atención personalizada",
    desc: "Te asesoramos según lo que realmente necesitas.",
  },
  {
    icon: "Boxes",
    title: "Variedad de productos",
    desc: "Amplio catálogo de consumibles, accesorios y equipo.",
  },
  {
    icon: "Cpu",
    title: "Soluciones tecnológicas",
    desc: "Desde una impresión hasta cámaras de seguridad e IP.",
  },
  {
    icon: "Wrench",
    title: "Servicio técnico especializado",
    desc: "Reparación y mantenimiento a computo, celular e impresión.",
  },
  {
    icon: "Zap",
    title: "Rapidez y confianza",
    desc: "20 años de experiencia respaldan cada trámite.",
  },
  {
    icon: "MapPin",
    title: "4 sucursales en Cortazar",
    desc: "Siempre cerca de ti donde nos necesites.",
  },
];

export const CLIENTS = [
  "Comercializadora PEPSICO México",
  "Cruz Roja Mexicana",
  "Farmacias Guadalajara",
  "Gobierno del Estado de Guanajuato",
  "Iglesia Metodista de México",
  "Municipio de Cortazar, Guanajuato",
  "Municipio de Yuriria",
  "Partido Acción Nacional",
  "Productos Regionales del Bajío",
  "HRL Call Center",
  "Constructora y Comercializadora Creek",
  "Whirlpool México",
];
